import React from 'react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate'
import HotelsDropDown from '../../shared/HotelsDropDown'
import { GetAddonsByReservationReport } from '../../../api/services/finance'
import { DatePicker } from '../../shared/DatePicker'
import { Form } from 'semantic-ui-react'
import { useTextResources } from '../../../language'
import moment from 'moment'
import { endpoint } from '../../../api/http'
import { dateFormat } from '../../shared/constants'

const AddonsByReservationReport = ()=>{
    const text = useTextResources()
    const formatter = ({value})=>{
        return value ? value.toFixed(2) : 0.00
    }
    
    const dateFormatter = ({value})=>{
        return value&&moment(value).format(dateFormat)
    }
    
    const reservationFormatter = ({value, row})=>{
        return <a target="_blank" rel="noopener noreferrer" href={`${endpoint}PMS/Reservations/Index/${row.ReservationId}?hotelid=${row.HotelId}`}>{value}</a>
    }

    // Shared summary column names for both UI and Excel export
    const summarizedColumnNames = [
        'AdultAmountBeforeTax',
        'AdultAmountAfterTax',
        'ChildAmountBeforeTax',
        'ChildAmountAfterTax',
        'RoomAmountBeforeTax',
        'RoomAmountAfterTax',
        'ComputedTotalBeforeTax',
        'ComputedTotalAfterTax'
    ];
     
    const gridOptions = {
        search: {
            title: text("AddonsByReservationReport"),
            description: text("AddonPricesPerReservation"),
            fields: [ 
                <DatePicker 
                    type="basic"
                    label= {text("StartDate")} 
                    name="StartDate"
                    key="StartDate"
                />,
                <DatePicker 
                    type="basic"
                    label= {text("EndDate")}
                    name="EndDate"
                    key="EndDate"
                />,
                <Form.Field control={HotelsDropDown} width="4" multiple label= {text("Hotel")} key="HotelIDs"/>
            ],
            api: GetAddonsByReservationReport
        },
        grid: {
            // TODO: Add child amounts
            // TODO: Add totals DONE
            // TODO: Word Wrap in titles
            columns: [
                { name: 'HotelName', title: text('Hotel') },
                { name: 'Name', title: text('AddonName') },
                { name: 'Reservation_Number', title: text('Reservation'), formatter: reservationFormatter },
                { name: 'RoomTypeName', title: text('RoomType') },
                { name: 'Status', title: text('Status') },
                { name: 'Nationality', title: text('Nationality') },
                { name: 'Date', title: text('Date'), formatter: dateFormatter },
                { name: 'AdultQuantity', title: text('Quantity'), exportTitle: text('AdultQuantity') },
                { name: 'AdultAmountBeforeTax', title: text('NotIncTax'), exportTitle: text('AdultPriceNotIncTax'),  formatter },
                { name: 'AdultAmountAfterTax', title: text('IncTaxBlock'), exportTitle: text('AdultPriceIncTax'), formatter },
                { name: 'ChildQuantity', title: text('Quantity'), exportTitle: text('ChildQuantity') },
                { name: 'ChildAmountBeforeTax', title: text('NotIncTax'), exportTitle: text('ChildPriceNotIncTax'), formatter },
                { name: 'ChildAmountAfterTax', title: text('IncTaxBlock'), exportTitle: text('ChildPriceIncTax'), formatter },
                { name: 'Quantity', title: text('Quantity'), exportTitle: text('RoomQuantity') },
                { name: 'RoomAmountBeforeTax', title: text('NotIncTax'), exportTitle: text('RoomPriceNotIncTax') , formatter },
                { name: 'RoomAmountAfterTax', title: text('IncTaxBlock'), exportTitle: text('RoomPriceIncTax') , formatter },               
                { name: 'ComputedTotalBeforeTax', title: text('NotIncTax'), exportTitle: text('ComputedTotalNotIncTax') , formatter },
                { name: 'ComputedTotalAfterTax', title: text('IncTaxBlock'), exportTitle: text('ComputedTotalIncTax') , formatter },
                { name: 'Currency', title: text('Currency') }
            ],
            columnBands: [
                {
                    title: text("AdultPrice"),
                    children: [{ columnName: 'AdultAmountBeforeTax' }, { columnName: 'AdultAmountAfterTax' },  { columnName: 'AdultQuantity' }]
                },
                {
                    title: text("ChildPrice"),
                    children: [{ columnName: 'ChildAmountBeforeTax' }, { columnName: 'ChildAmountAfterTax' }, { columnName: 'ChildQuantity' }]
                },
                {
                    title: text("RoomPrice"),
                    children: [{ columnName: 'Quantity' }, { columnName: 'RoomAmountBeforeTax' }, { columnName: 'RoomAmountAfterTax' }]
                },
                {
                    title: text("ComputedTotal"),
                    children: [{ columnName: 'ComputedTotalBeforeTax' }, { columnName: 'ComputedTotalAfterTax' }]
                }
            ],
            pdf: true,
            summary: true, 
            export: true,
            excel: {
                // Excel export uses raw numeric sums; UI formatters are not applied here so that
                // Excel can handle number formatting (and potential post-processing) itself.
                totalSummaryItems: summarizedColumnNames.map(columnName => ({ columnName, type: 'sum' }))
            },
            totalSummaryItems: summarizedColumnNames.map(columnName => ({ columnName, type: 'sum', formatter }))
        }
    }
    return (<GridSearchTemplate options={gridOptions}/>)
}

export default AddonsByReservationReport